import { render, staticRenderFns } from "./amount.vue?vue&type=template&id=ed74fb02"
import script from "./amount.vue?vue&type=script&lang=js"
export * from "./amount.vue?vue&type=script&lang=js"
import style0 from "./amount.vue?vue&type=style&index=0&id=ed74fb02&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports